/**
 * Feature flags — flip these in one place to enable/disable large
 * feature swaps without reverting unrelated code. When a flag is
 * false the application must render as it did before the feature
 * landed.
 */
export const NI2_CONTEXTUAL_FILES_ENABLED = true;
export const MM_BUILDER_ENABLED = true;

/**
 * Live GPT vs deterministic demo mode.
 * When AI_LIVE_ENABLED is true, the runtime toggle starts ON so a
 * demo boots straight into Live GPT if the server has any capable
 * key. If the server has no key, `LiveModeContext` reports
 * `liveActive=false` and the deterministic path is used instead —
 * so this default is safe to ship in production.
 */
export const AI_LIVE_ENABLED = true;
